import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import CommentPost from 'flarum/forum/components/CommentPost';

import EmojiPostReactAction from './src/forum/components/EmojiPostReactAction';

// Registered with a negative priority so it runs AFTER fof/reactions' initializer
// and replaces the small built-in reaction palette with the full WhatsApp-style picker.
app.initializers.add(
  'florcarioca/emoji-all',
  () => {
    extend(CommentPost.prototype, 'actionItems', function (items) {
      const post = this.attrs.post;

      if (post.isHidden()) return;

      items.add('react', EmojiPostReactAction.component({ post }), 5);
    });
  },
  -100
);